<div class="login-page">
  <div class="panel">
    <img
      src="/assets/images/smart-lga-logo.png"
      class="smart-lga-logo"
      alt=""
    />

    <form class="wrapper" [formGroup]="loginForm">
      <h6
        style="
          color: #074a97;
          text-decoration: underline;
          text-align: center;
          font-weight: 800;
          font-size: 24px;
        "
      >
        USER LOGIN
      </h6>

      <div class="field">
        <label for="" class="form-label">Email</label>
        <input
          type="email"
          class="form-control"
          formControlName="email"
          [maxlength]="50"
          placeholder="example@gmail.com"
        />
      </div>

      <div class="field">
        <label for="">Password</label>
        <div class="password-input" style="position: relative">
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            formControlName="password"
            placeholder="************"
            [maxlength]="50"
          />
          <span
            class="material-symbols-outlined"
            style="
              position: absolute;
              right: 10px;
              bottom: 7px;
              cursor: pointer;
            "
            (click)="toggleShowPassword()"
          >
            {{ showPassword ? "visibility" : "visibility_off" }}
          </span>
        </div>
      </div>

      <span class="error-container" *ngIf="errorMessage">{{
        errorMessage
      }}</span>

      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-2"
      >
        <label class="checklist-item">
          <input type="checkbox" formControlName="rememberMe" /> Remember me
        </label>
        <span href="#" style="color: black; text-decoration: underline; cursor: pointer;" (click)="forgotPassword()">Forgot Password</span>
      </div>

      <div *ngIf="showCaptcha">
        <app-puzzle-captcha
          (captchaResult)="handleCaptcha($event)"
        ></app-puzzle-captcha>
      </div>

      <button
        class="btn-deep-blue w-100"
        [disabled]="loginForm.invalid || loginInProgress"
        (click)="attemptLogin()"
      >
        LOG IN
        <div class="spinner-light" *ngIf="loginInProgress"></div>
      </button>
    </form>
  </div>
</div>
